/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dns_Records_Not_Detected_YetInputs */

const en_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS records not detected yet. Please wait propagation.`)
};

const es_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros DNS aún no detectados. Por favor, espera la propagación.`)
};

const fr_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements DNS non détectés pour l'instant. Veuillez attendre la propagation.`)
};

const de_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS-Einträge noch nicht erkannt. Bitte warte auf die Verbreitung.`)
};

const ja_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNSレコードがまだ検出されていません。伝播をお待ちください。`)
};

const zh_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未检测到 DNS 记录。请等待解析完成。`)
};

const ar_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم اكتشاف سجلات DNS بعد. الرجاء انتظار الانتشار.`)
};

const id_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekaman DNS belum terdeteksi. Harap tunggu proses propagasi.`)
};

const it_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record DNS non ancora rilevati. Si prega di attendere la propagazione.`)
};

const ru_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи DNS пока не обнаружены. Пожалуйста, дождитесь обновления.`)
};

const pt_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros DNS não detectados ainda. Por favor, aguarde a propagação.`)
};

const ko_dns_records_not_detected_yet = /** @type {(inputs: Dns_Records_Not_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS 레코드가 아직 감지되지 않았습니다. 전파될 때까지 기다려 주세요.`)
};

/**
* | output |
* | --- |
* | "DNS records not detected yet. Please wait propagation." |
*
* @param {Dns_Records_Not_Detected_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dns_records_not_detected_yet = /** @type {((inputs?: Dns_Records_Not_Detected_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dns_Records_Not_Detected_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dns_records_not_detected_yet(inputs)
	if (locale === "es") return es_dns_records_not_detected_yet(inputs)
	if (locale === "fr") return fr_dns_records_not_detected_yet(inputs)
	if (locale === "de") return de_dns_records_not_detected_yet(inputs)
	if (locale === "ja") return ja_dns_records_not_detected_yet(inputs)
	if (locale === "zh") return zh_dns_records_not_detected_yet(inputs)
	if (locale === "ar") return ar_dns_records_not_detected_yet(inputs)
	if (locale === "id") return id_dns_records_not_detected_yet(inputs)
	if (locale === "it") return it_dns_records_not_detected_yet(inputs)
	if (locale === "ru") return ru_dns_records_not_detected_yet(inputs)
	if (locale === "pt") return pt_dns_records_not_detected_yet(inputs)
	return ko_dns_records_not_detected_yet(inputs)
});